export * from './user-add.component';
export * from './user-add.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/user/user-add/index.ts